export const grades = [
  { id: 1, name: "KG 1" },
  { id: 2, name: "KG 2" },
  { id: 3, name: "1st Grade" },
  { id: 4, name: "2nd Grade" },
  { id: 5, name: "3rd Grade" },
  { id: 6, name: "4th Grade" },
  { id: 7, name: "5th Grade" },
  { id: 8, name: "6th Grade" },
  { id: 9, name: "7th Grade" },
  { id: 10, name: "8th Grade" },
  { id: 11, name: "9th Grade" },
  { id: 12, name: "10th Grade" },
  { id: 13, name: "11th Grade" },
  { id: 14, name: "12th Grade" },
];

export const getGradeName = (id) => {
  return grades.find((grade) => grade.id == id)?.name;
};
